// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

* {
  font-family: "Courier New", Courier, monospace !important;
  box-sizing: border-box;
}

svg {
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  position: fixed;
}

svg line:hover,
svg circle:hover,
svg path:hover,
svg text:hover {
  stroke: red;
  background-color: red;
  fill-color: red;
  /*stroke-width: 2px;*/
}

.phantomBackground:hover {
  stroke: red;
  stroke-opacity: 0.2;
}

#canvas {
  user-select: none;
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE/Edge */
}



.toolbar {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 30px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
  z-index: 1000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  filter: invert(1);
}

.selectWidgetToolbar {
  width: 100%;
  height: 30px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
  z-index: 1000;
  display: flex;
  align-items: center;
  filter: invert(1);
}

.toolButton {
  margin: 3px;
  height: 30px;
  width: 30px;
  align-items: center;
  
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;;AAErB","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n* {\n  font-family: \"Courier New\", Courier, monospace !important;\n  box-sizing: border-box;\n}\n\nsvg {\n  width: 100%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  position: fixed;\n}\n\nsvg line:hover,\nsvg circle:hover,\nsvg path:hover,\nsvg text:hover {\n  stroke: red;\n  background-color: red;\n  fill-color: red;\n  /*stroke-width: 2px;*/\n}\n\n.phantomBackground:hover {\n  stroke: red;\n  stroke-opacity: 0.2;\n}\n\n#canvas {\n  user-select: none;\n  -webkit-user-select: none;\n  /* Safari */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* IE/Edge */\n}\n\n\n\n.toolbar {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 30px;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #ccc;\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  filter: invert(1);\n}\n\n.selectWidgetToolbar {\n  width: 100%;\n  height: 30px;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #ccc;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  filter: invert(1);\n}\n\n.toolButton {\n  margin: 3px;\n  height: 30px;\n  width: 30px;\n  align-items: center;\n  \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
